// const baseUrl = 'http://192.168.68.117:8080'; // 测试环境
// const baseUrl = 'http://10.226.172.175:8080'; //
// const baseUrl = 'http://10.224.192.35:8080'; // 雪
const baseUrl = "https://dpm.deppon.com:8881"; // 生产

const address = {
  // 根据题目id查询题目列表
  mainUrl: baseUrl + '/dpm/dpm-management/question_getAnswerExamListByExamId.action',
  // 保存监控记录
  applyData: baseUrl + '/dpm/dpm-management/question_insertAnswerMonitor.action'
}

export default address;



// WEBPACK FOOTER //
// ./src/libs/address.js